import { animated, useSpring } from "react-spring";
import { springConfigs } from "../../constants/springConfigs";

export const WhiteLine = () => {
  const { opacity } = useSpring({
    from: { opacity: 0.0 },
    to: { opacity: 0.05 },
    config: springConfigs.backgroundTransitions,
  });
  return (
    <animated.div
      id="WhiteLine"
      style={{
        gridArea: "line",
        minWidth: "1px",
        opacity,
        // position: "absolute",
        // right: 0,
        height: "100%",
        backgroundColor: "#ffffff",
      }}
    />
  );
};
